import React from 'react';
import './Roadmap.css';
// import { Link } from 'react-router-dom';
import roadmapOne from '../../../assets/Gallery/roadmapOne.png'
import roadmapTwo from '../../../assets/Gallery/roadmapTwo.png'
import roadmapThree from '../../../assets/Gallery/roadmapThree.png'

function Roadmap() {
    return (
        <div className='roadmap-outer'>
            <div className="roadmap-inner">
                <h2 className='header-text'>Where can you see yourself?</h2>
                {/* this is where the three sections comes together */}
                <div className="hotel-management">
                    <div className="first-box">
                        <h4 className='secondary-paragraph'>Placed in One of The Top Cruise Lines</h4>
                        <p className="letter-text">At LIMS, we take pride in preparing our students for global opportunities in the hospitality industry. Our alumni have secured placements with some of the world’s leading cruise lines—renowned for their high standards and international clientele. With comprehensive training in customer service, culinary skills, and onboard operations, our graduates step confidently into careers that take them across oceans. This milestone reflects not just a job—but a journey of global exposure, growth, and excellence.
                        </p>
                    </div>
                    <div className="second-box">
                        <div className="second-box-img">
                            <img src={roadmapOne} alt="" loading='lazy'/>
                        </div>
                    </div>
                    <div className="third-box">
                        <h4 className='paragraph-text'>Speicalization and certificate course in Front Office Management</h4>
                        {/* <button className='cta-text'><Link to='/bar-management'>Know More</Link></button> */}
                    </div>
                </div>
                <div className="cruise-industry">
                    <div className="third-box">
                        <h4 className='paragraph-text' id='second-in-third-box'>Speicalization and certificate course in Wine And Bar Management</h4>
                        {/* <button className='cta-text'><Link to='/bar-management'>Know More</Link></button> */}
                    </div>
                    <div className="second-box">
                        <div className="second-box-img">
                            <img src={roadmapTwo} alt="" loading='lazy'/>
                        </div>
                    </div>
                    <div className="first-box">
                        <h4 className='paragraph-text'>Get WCT Australia Expert's Knowledge and Advice</h4>
                        <p className="letter-text">At LIMS, we are proud to collaborate with experts from WCT Australia to provide our students with globally recognized insights into the hospitality and tourism industry. Through expert-led sessions, industry-focused training modules, and real-world case studies, students gain a deep understanding of international standards and best practices. This collaboration ensures that our learners are not only industry-ready but also equipped to thrive in global hospitality careers.
                        </p>
                    </div>
                </div>
                <div className="cabin-crew d-flex justify-content-between">
                    <div className="second-box w-25">
                        <div className="second-box-img ">
                            <img src={roadmapThree} alt="" loading='lazy'/>
                        </div>
                    </div>
                    <div className="first-box ">
                        <h4 className='paragraph-text'>Master of Food Safety and Quality Management</h4>
                        <p className="letter-text">Food safety and quality are critical pillars of the hospitality and food service industries. Our Master of Food Safety and Quality Management program is designed to equip students with the scientific knowledge, regulatory understanding, and practical skills required to maintain the highest standards in food production, storage, and service. With a strong focus on global compliance and industry best practices, this program prepares students to take on leadership roles in ensuring safe, high-quality food across diverse settings.
                        </p>
                    </div>
                    <div className="third-box ">
                        <h4 className='paragraph-text'>Speicalization and certificate course in Kitchen Operations Management</h4>
                        {/* <button className='cta-text'><Link to='/bar-management'>Know More</Link></button> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Roadmap
